module.exports = __webpack_public_path__ + "img/riskmanagement-slide.min.eeef6676.jpg";